var _a;
import React from 'react';
import styled, { css } from 'styled-components';
import * as Button from '@commoncomponents/frontend-components/dist/components/Buttons';
import Snackbar from '../../Snackbar';
import { Header } from '../components';
import { Wrapper } from '../styled';
import { theme } from '../../../styled';
const clockIllustration = (_a = require('../media/Illustrations/Clock.svg')) === null || _a === void 0 ? void 0 : _a.default;
const ErrorPage = ({ translations, onClick, onClickBypass, variant, showButton, showBypassButton, showBar, closeBar, disabled, }) => {
    const { title, description, buttonTextResend, buttonTextBypass, snackbarMessage, } = translations;
    const showBothOptions = showButton && showBypassButton;
    return (React.createElement(Wrapper, null,
        React.createElement(Snackbar, { open: showBar, handleClose: closeBar, message: snackbarMessage, variant: variant, autoHideDuration: 4000, showIcon: true }),
        React.createElement(Header, null),
        React.createElement(Content, null,
            React.createElement(IllustrationWrapper, null,
                React.createElement("img", { src: clockIllustration, alt: "" })),
            React.createElement(LeftColumnWrapper, null,
                React.createElement(Title, null, title),
                React.createElement(Description, null, description),
                React.createElement(ButtonsWrapper, null,
                    showBypassButton && (React.createElement(Button.PrimaryRounded, { label: buttonTextBypass, disabled: disabled, onClick: onClickBypass, extraCss: css `
                  width: 100%;

                  @media (min-width: 768px) {
                    width: unset;
                  }
                ` })),
                    showBothOptions && (React.createElement(Button.GhostRounded, { label: buttonTextResend, disabled: disabled, onClick: onClick, extraCss: css `
                  width: 100%;
                  border: 1px solid ${theme.airlessPlatinium} !important;

                  @media (min-width: 768px) {
                    width: unset;
                  }
                ` })),
                    showButton && !showBothOptions && (React.createElement(Button.PrimaryRounded, { label: buttonTextResend, disabled: disabled, onClick: onClick, extraCss: css `
                  width: 100%;

                  @media (min-width: 768px) {
                    width: unset;
                  }
                ` })))))));
};
const Content = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: calc(100% - 64px);
  margin: auto;
  padding: 78px 16px 0;

  img {
    display: block;
    width: 100%;
  }

  @media (min-width: 768px) {
    max-width: 953px;
    flex-direction: row-reverse;
    justify-content: center;
    padding-top: 0;
  }
`;
const LeftColumnWrapper = styled.div `
  @media (min-width: 768px) {
    margin-right: 48px;
    flex-basis: 58%;
  }
`;
const Title = styled.h1 `
  font-size: 28px;
  font-weight: bold;
  line-height: 1.25;
  letter-spacing: -0.01px;
  color: ${theme.lameJet};
  margin-bottom: 16px;

  @media (min-width: 768px) {
    font-size: 32px;
  }
`;
const Description = styled.p `
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.04px;
  color: ${theme.lameJet};
  margin-bottom: 24px;
`;
const IllustrationWrapper = styled.div `
  margin-bottom: 48px;

  @media (min-width: 768px) {
    margin-bottom: unset;
    flex-basis: 43%;
  }
`;
const ButtonsWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    flex-direction: row;
    margin-bottom: unset;
  }
`;
export default ErrorPage;
